import { FunctionComponent } from 'preact';
import './Masthead.css';
import { useFeaturedBooks } from '../../hooks';
import { MastheadOverlay } from './MastheadOverlay';
import { MastheadGrid } from './MastheadGrid';

interface MastheadProps {
  limit?: number;
}

export const Masthead: FunctionComponent<MastheadProps> = ({ limit = 48 }) => {
  const { books, loading, error } = useFeaturedBooks(limit);

  const cdnUrl = import.meta.env.VITE_CDN_URL || '';
  const baseBookCoverImageUrl = '/uploads/covers/';

  // books.forEach((book) => {
  //   const images = [
  //     '400-coverImage-1741096086703-359857311.png',
  //     '400-coverImage-1741640030666-214775462.png',
  //   ];
  //   book.coverImageThumb = images[Math.floor(Math.random() * images.length)];
  // });
  return (
    <div className="masthead-container">
      <MastheadOverlay />
      <MastheadGrid
        limit={limit}
        books={books}
        loading={loading}
        error={error}
        cdnUrl={cdnUrl}
        baseBookCoverImageUrl={baseBookCoverImageUrl}
      />
    </div>
  );
};
